import { createAction, props } from '@ngrx/store';

export const loadRequest = createAction(
  '[City Tax Summary Statistics] Load Request',
);

export const loadSuccess = createAction(
  '[City Tax Summary Statistics] Load Success',
);

export const loadFailure = createAction(
  '[City Tax Summary Statistics] Load Failure',
  props<{ error: any }>(),
);

export const resetState = createAction(
  '[City Tax Summary Statistics] Reset State',
);
